/* eslint-disable import/prefer-default-export */
import { underscore } from 'inflection';

export function parameterize(str) {
  if (typeof str !== 'string') return str;
  return underscore(str).replace(/[^A-Za-z0-9]/, '_');
}

export function cleanName(str) {
  if (typeof str !== 'string') return str;
  return str.replace(/[0-9~`!@#$%^&*()_+=?/\\{}[\]|;:,<>]*/g, '');
}

export function isValidName(str) {
  const invalidregex = /[0-9~`!@#$%^&*()_+=?/\\{}[\]|;:,<>]/g;
  return !invalidregex.test(String(str));
}

export function isValidEmail(email) {
  const emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailregex.test(String(email).toLowerCase());
}
